import { useState } from 'react';
import { Gift, X, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getReferralCode, clearReferralCode } from '@/hooks/useReferralCapture';
import { toast } from 'sonner';
import { trackGenericEvent } from '@/lib/crm/track';

interface ReferralBannerProps {
  onApplyCoupon?: (code: string) => void;
}

export const ReferralBanner = ({ onApplyCoupon }: ReferralBannerProps) => {
  const [isApplied, setIsApplied] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  
  const referralCode = getReferralCode();

  if (!referralCode || isDismissed) return null;

  const handleApply = () => {
    if (onApplyCoupon) {
      onApplyCoupon(referralCode);
    }
    
    // Copy to clipboard as fallback
    navigator.clipboard.writeText(referralCode).then(() => {
      toast.success(`Código ${referralCode} copiado! Cole no checkout.`);
    });
    
    setIsApplied(true);
    trackGenericEvent('referral_coupon_applied', { code: referralCode });
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    clearReferralCode();
    trackGenericEvent('referral_coupon_dismissed');
  };

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-3 mb-4">
      <div className="flex items-start gap-3">
        <Gift className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">
            Você tem um benefício de indicação!
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Código: <span className="font-mono font-semibold">{referralCode}</span>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {isApplied ? (
            <span className="flex items-center gap-1 text-xs text-green-600">
              <Check className="h-4 w-4" />
              Copiado
            </span>
          ) : (
            <Button size="sm" variant="secondary" onClick={handleApply}>
              Aplicar
            </Button>
          )}
          <Button size="icon" variant="ghost" className="h-6 w-6" onClick={handleDismiss}>
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
